export interface IMicrositeCampaignLetter {
    salutation: string,
    intro: string,
    closing: string,
    signature: string
}